export default __webpack_public_path__ + "img/IgGlbRQQ.47056471.svg";